var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateInteraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.01 45.4653C12.1746 45.4653 2.55469 35.8453 2.55469 24.01C2.55469 12.1746 12.1746 2.55469 24.01 2.55469C35.8453 2.55469 45.4653 12.1746 45.4653 24.01C45.4653 35.8453 35.8254 45.4653 24.01 45.4653ZM24.01 5.54845C13.8312 5.54845 5.54845 13.8312 5.54845 24.01C5.54845 34.1888 13.8312 42.4715 24.01 42.4715C34.1888 42.4715 42.4715 34.1888 42.4715 24.01C42.4715 13.8312 34.1888 5.54845 24.01 5.54845Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6006 25.9055C28.2014 25.9055 27.8222 25.7458 27.5428 25.4664L11.2168 9.10047C10.638 8.52168 10.638 7.56367 11.2168 6.98488C11.7956 6.40608 12.7536 6.40608 13.3324 6.98488L27.1237 20.7961L27.1436 15.3275C27.1436 14.5092 27.8222 13.8306 28.6405 13.8306C29.4588 13.7707 30.1374 14.5092 30.1374 15.3275L30.1174 24.4086C30.1174 25.0073 29.7582 25.5662 29.1993 25.7857C28.9998 25.8655 28.8002 25.9055 28.6006 25.9055Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7256 41.4544C35.3464 41.4544 34.9672 41.3147 34.6678 41.0153L20.8765 27.2041L20.8566 32.6727C20.8566 33.491 20.178 34.1696 19.3597 34.1696C18.5414 34.1696 17.8628 33.491 17.8628 32.6727L17.8828 23.5916C17.8828 22.9928 18.242 22.434 18.8008 22.2145C19.3597 21.975 19.9983 22.1147 20.4374 22.5338L36.7634 38.8997C37.3422 39.4785 37.3422 40.4365 36.7634 41.0153C36.504 41.3147 36.1048 41.4544 35.7256 41.4544Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateInteraction);
export default __webpack_public_path__ + "static/media/EmptyStateInteraction.5c605684.svg";
export { ForwardRef as ReactComponent };